import React from 'react'
import { today } from './inventoryData';
import { Field, PanelTitle } from './InventoryShared';

function PurchaseWorkflowPage({ title, action = 'Save', items, suppliers }) {
    return (
        <section className='inventory-panel inventory-form-page'>
            <PanelTitle title={title} />
            <div className='inventory-form-grid two-column'>
                <Field label='Supplier Name' type='select' options={suppliers.map(item => item.name)} />
                <Field label='Document Number' placeholder='DOC-1024' />
                <Field label='Document Date' type='date' defaultValue={today} />
                <Field label='Item Name' type='select' options={items.map(item => item.name)} />
                <Field label='Quantity' type='number' placeholder='20' />
                <Field label='Expected Amount' type='number' placeholder='4500' />
            </div>
            <div className='inventory-actions sticky'><button>{action}</button></div>
        </section>
    );
}

export default PurchaseWorkflowPage
